export default {
  setAdmin (state, admin) {
    state.admin.id = admin.id
    state.admin.firstname = admin.firstname
    state.admin.lastname = admin.lastname
    state.admin.role = admin.role
    state.admin.username = admin.username
    state.admin.email = admin.email
    state.admin.phone_number = admin.phone_number
    state.admin.line_id = admin.line_id
    state.admin.profile_image_url = admin.profile_image_url
    state.admin.permission = admin.permission
    state.admin._token = admin._token
  },
  logout (state) {
    state.admin.id = 0
    state.admin.firstname = ''
    state.admin.lastname = ''
    state.admin.role = ''
    state.admin.username = ''
    state.admin.email = ''
    state.admin.phone_number = ''
    state.admin.line_id = ''
    state.admin.profile_image_url = ''
    state.admin.permission = []
    state.admin._token = ''
  }
}